import { Page } from "@/models/page-models/Page";

export const RawMaterialPurchaseOrderAdd: Page = {
  "path": "add-purchase-order",
  "name": "Create RM/ORM PO",
  "props": {
    "data": {
      "title": "Create PO",
      "printable": "FALSE",
      "url": "add-purchase-order",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "PO Code",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,poCode,{{formData}},{{fetchedData}})"
                },
                {
                  "type": "label",
                  "label": "PO Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier",
                  "label": "Select Supplier",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySupplier",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedSupplier"
                      },
                      "name": "copySupplier"
                    },
                    {
                      "executionOrder": 1,
                      "name": "copySupplierInternationalStatus"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultPageNo",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultPageNo",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.goodSearch",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultPageNo"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getRmsBySupplier",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/goods/supplier/{{formData.supplier}}/raw-material",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.goods",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.goodSearch"
                      },
                      "name": "getRmsBySupplier"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "copyRMs",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.goods.data.docs",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.filteredGoods"
                      },
                      "name": "copyRMs"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyDefaultSupplierShippingTerms",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultSupplierShippingTerms",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultSupplierShippingTerms"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "validationKey": "supplier"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Supplier Shipping Info"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.currencyCode",
                  "label": "Currency Code",
                  "disabled": "FALSE",
                  "items": "[\"EUR\",\"USD\",\"SAR\",\"AED\"]",
                  "dropdownType": "static",
                  "validationKey": "currencyCode"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.deliveryTerms",
                  "label": "Trade Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.paymentTerms",
                  "label": "Payment Terms",
                  "disabled": "FALSE",
                  "items": "[\"CAD (Cash Against Documents)\",\"DFT30 (Draft 30 days from B/L Date)\",\"DFT60 (Draft 60 days from B/L Date)\",\"DFT90 (Draft 90 days from B/L Date)\",\"DFT120 (Draft 120 days from B/L Date)\",\"LC SGHT (ICLC Payable at Sight)\",\"LC30 (ICLC 30 days from B/L Date)\",\"LC45 (ICLC 45 days from B/L Date)\",\"LC60 (ICLC 60 days from B/L Date)\",\"LC90 (ICLC 90 days from B/L Date)\",\"LC120 (ICLC 120 days from B/L Date)\",\"TLX ADV (Advance Telex Transfer)\",\"TLX (Telex Transfer Upon Receipt)\",\"CHQ30 (Cheque 30 days on Goods Receipt)\",\"CHQ45 (Cheque 45 days on Goods Receipt)\",\"CHQ60 (Cheque 60 days on Goods Receipt)\",\"Cash\",\"FOC\",\"CHQ 75 Days from Date of Shipping\",\"CHQ 90 Days from Date of Shipping\",\"On Account\",\"TLX Transfer 120 Days from BL/TWB DATE\",\"TLX Transfer 90 Days from BL/TWB DATE\",\"TLX Transfer 60 Days from BL/TWB DATE\",\"TLX Transfer 30 Days from B/L DATE\",\"Cash in Advance Prior to Shipment By ...\",\"Advance 30% and CAD 70%\",\"Avalised Draft 90 days from BL/TWB Date\",\"Avalised Draft 60 days from B/L Date\",\"CAD 30 days with 2% discount on Invoice\",\"CAD 60 days from B/L Date\",\"CAD 75 days from B/L Date\",\"CAD 90 days from B/L Date\",\"CAD 120 days from B/L Date\",\"CAD 60 days from Invoice Date\",\"CAD 90 days from Invoice Date\",\"CAD 120 days from Invoice Date\",\"Telex Transfer - 50% Advance & 50% Before ...\",\"CAD 60 days\",\"CAD 90 days\"]",
                  "dropdownType": "static",
                  "validationKey": "paymentTerms"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.packingMode",
                  "label": "Packing Mode",
                  "disabled": "FALSE",
                  "items": "[\"Wrapped Rolls for Sea Worthy Shipment\",\"In brand new Steel Drums on Pallet ...\",\"In Rolls, Wrapped and Protected\",\"In Carton Box on Pallets Wrapped\",\"In Rolls, Wrapped and Protected with ...\",\"Wrapped Board For Seaworthy Shipment\",\"Usual Packing\",\"Carton Box\",\"In Rolls, Protected with Strong\",\"None\"]",
                  "dropdownType": "static",
                  "validationKey": "packingMode"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.shippingMarks",
                  "label": "Shipping Marks",
                  "disabled": "FALSE",
                  "items": "[\"Made In Germany\",\"Made In Brazil\",\"Made In Canada\",\"Made In India\",\"Made In Denmark\",\"Made In Belgium\",\"Made In U.S.A\",\"Made In China\",\"Made In Indonesia\",\"Made In Korea\",\"Made In K.S.A\",\"Made In Qatar\",\"Made in Sweden\",\"Made in France\",\"Made in Turkey\",\"Made in Spain\",\"Made in UAE\"]",
                  "dropdownType": "static",
                  "validationKey": "shippingMarks"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "FALSE",
                  "items": "[\"Ocean Vessel 20FT Container\",\"Ocean Vessel 40FT Container\",\"Ocean Vessel Break Bulk(Pallets)/ Tons ( LCL Shipment)\",\"Groupage Container Ocean Vessel\",\"Air Freight\",\"Air Post Parcel\",\"Van\",\"DHL Courier Service\",\"Purchaser\",\"Sea Freight\",\"Supplier\",\"Truck\",\"Road Tanker\",\"Ocean Vessel 20FT ISO Tanker\",\"None\"]",
                  "dropdownType": "static",
                  "validationKey": "shippingMode"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.shippingDate",
                  "label": "Shipping Date",
                  "disabled": "FALSE",
                  "showWeekNumber": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.homePort",
                  "label": "Destination Port",
                  "disabled": "FALSE",
                  "items": "[\"Dammam\",\"Jeddah\"]",
                  "dropdownType": "static",
                  "validationKey": "homePort"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.notes",
                  "label": "Additional Notes",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.requiredDocuments",
          "label": "Documents Required",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "name"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "FALSE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "FALSE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "initialValue": [
            {
              "name": "Invoice"
            },
            {
              "name": "Certificate of Origin"
            },
            {
              "name": "B/L/AWB"
            },
            {
              "name": "Packing List"
            },
            {
              "name": "Insurance Certificate"
            },
            {
              "name": "Certificate of Analysis"
            }
          ],
          "disableAddDelete": true
        },
        {
          "type": "arrayGroup",
          "variable": "formData.additionalDocuments",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "FALSE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "FALSE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "initialArrayLength": 0
        },
        {
          "type": "arrayGroup",
          "variable": "formData.purchasedRMs",
          "label": "Raw Materials",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "rawMaterial",
                  "label": "Raw Material",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyRMType"
                    },
                    {
                      "executionOrder": 2,
                      "name": "getFilteredRMs"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredGoods",
                  "itemText": "mainSpecification",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,goodsName,{{__item}})",
                  "maxWidth": "33%"
                },
                {
                  "type": "input",
                  "variable": "unitQuantity",
                  "label": "Quantity",
                  "unit": "{{fn(GET_GOOD,{{__arrayGroup3.rawMaterial}},rawMaterialUnit)}}",
                  "disabled": "FALSE",
                  "inputType": "convert",
                  "enableConvertFnFlag": "fn(LOGICAL,fn(CONCAT,',{{fn(GET_GOOD,{{__arrayGroup3.rawMaterial}},rawMaterialUnit)}},'),==,'SQM')",
                  "convertFn": "sqmToKg",
                  "goodsId": "{{__arrayGroup3.rawMaterial}}"
                },
                {
                  "type": "input",
                  "variable": "tolerance",
                  "label": "Tolerance",
                  "unit": "%",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "unitPrice",
                  "label": "Unit Price",
                  "unit": "{{formData.currencyCode}}",
                  "disabled": "FALSE",
                  "inputType": "convert",
                  "enableConvertFnFlag": "fn(LOGICAL,fn(CONCAT,',{{fn(GET_GOOD,{{__arrayGroup3.rawMaterial}},rawMaterialUnit)}},'),==,'SQM')",
                  "convertFn": "priceSqmToKg",
                  "goodsId": "{{__arrayGroup3.rawMaterial}}"
                },
                {
                  "type": "input",
                  "variable": "exemption",
                  "label": "Customs RM Name",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "style": "border"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create PO",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "submitPurchaseOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "TRUE",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMySuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/my",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getMySuppliers",
        "executeIf": "fn(MATCH_ROLE,Commercial | Purchaser)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyPoType",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getPoType",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyPoType"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      }
    ],
    "functions": [
      {
        "name": "copyRMType",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.type",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.rmType"
      },
      {
        "name": "copySupplierInternationalStatus",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.isInternational",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.isInternational"
      },
      {
        "name": "filterRMs",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.goods.data.docs",
        "arg2Key": "searchKey",
        "arg2Value": "type",
        "arg3Key": "searchValue",
        "arg3Value": "{{fetchedData.rmType}}"
      },
      {
        "name": "getFilteredRMs",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterRMs",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredGoods"
      },
      {
        "name": "submitPurchaseOrder",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/save",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "redirectToSavedPo",
        "arg4Key": "storeResponse",
        "arg4Value": "TRUE"
      },
      {
        "name": "redirectToSavedPo",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/add-purchase-order/{{__response.data._id}}"
      },
      {
        "name": "getPoType",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "Raw Material"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultSupplierShippingTerms",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "currencyCode": "{{fetchedData.selectedSupplier.termsAndConditions.currency}}",
          "deliveryTerms": "{{fetchedData.selectedSupplier.termsAndConditions.deliveryTerms}}",
          "paymentTerms": "{{fetchedData.selectedSupplier.termsAndConditions.paymentTerms}}",
          "packingMode": "{{fetchedData.selectedSupplier.termsAndConditions.packingMode}}",
          "shippingMarks": "{{fetchedData.selectedSupplier.termsAndConditions.shippingMarks}}",
          "shippingMode": "{{fetchedData.selectedSupplier.termsAndConditions.shippingMode}}",
          "homePort": "{{fetchedData.selectedSupplier.termsAndConditions.destinationPort}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": true,
  "routerPriority": 90
}